import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import { LayoutLeftThirdShell } from 'components/authorable/layout/LayoutLeftThird/LayoutLeftThird';
import SearchListingFacets from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/SearchListing/SearchListingFacets';
import SearchListingStats from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/SearchListing/SearchListingStats';
import { classnames } from 'tailwindcss-classnames';
import SearchListingResults from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/SearchListing/SearchListingResults';
import SearchListingSort from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/SearchListing/SearchListingSort';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { Routes } from '.generated/templates/Project.Routes.model';
import { getEnumValue } from 'lib/util/enum';
import { MissingDataSource } from 'components/helpers/EditingHelpText';

export interface SearchListingProps {
  fields?: {};
}

const SearchListing = () => {
  const sitecoreContext = useSitecoreContext();
  const { fields } = sitecoreContext.sitecoreContext.route as Routes.SearchListingPage;
  if (!fields) {
    return <MissingDataSource />; // No fields? Exit early
  }
  if (!fields?.searchCategory) {
    return <MissingDataSource />;
  }
  const searchableCategory = getEnumValue(fields?.searchCategory);
  const ifNewsRoom = searchableCategory === 'Newsroom';
  return (
    <LayoutPageSectionShell theme="theme-white">
      <div
        className={classnames(
          'flex',
          'flex-col',
          'md:items-center',
          'justify-between',
          'w-full',
          'pb-6',
          'md:flex-row',
          'lg:pt-4',
          'lg:pb-2'
        )}
      >
        <SearchListingStats />
        <span className={classnames('hidden', 'lg:block')}>
          <SearchListingSort />
        </span>
      </div>
      {ifNewsRoom ? (
        <SearchListingResults searchCategory={searchableCategory} />
      ) : (
        <LayoutLeftThirdShell
          left={<SearchListingFacets searchCategory={searchableCategory} />}
          right={<SearchListingResults searchCategory={searchableCategory} />}
          isSearchPage
        />
      )}
    </LayoutPageSectionShell>
  );
};

export default SearchListing;
